import api from "./api";
export type DeleteContactDto = {
    id: number | string;
  };
  export const getContactTypes = async () => {
    return await api.get("/contactTypes");
  };